import { toast, ToastOptions, ToastPromiseParams } from 'react-toastify';
import { customFonts } from '../../styles';

// cant use makeStyles for this since makeStyles returns a hook and hooks can only be used in a component or another hook
const toastStyle: React.CSSProperties = {
    fontSize: '18px',
    color: 'black',
    fontFamily: customFonts.TitleFont,
    border: '1px solid black',
    marginTop: '33px',
};

const toastOptions: ToastOptions = {
    style: toastStyle,
};

// Centralized notification so that we don't have to repeat toast styles and toast.thing everywhere
// just import { alerts } from this file and call alerts.success('message'), alerts.error('message'), etc. wherever you need to show a notification
export const alerts = {
    success: (message: string) => toast.success(message, toastOptions),
    error: (message: string) => toast.error(message, toastOptions),
    warning: (message: string) => toast.warning(message, toastOptions),
    info: (message: string) => toast.info(message, toastOptions),
    promise: <TData, TError = unknown, TPending = unknown>(
        promise: Promise<TData> | (() => Promise<TData>),
        messages: ToastPromiseParams<TData, TError, TPending>,
        options?: ToastOptions<TData>,
    ): Promise<TData> =>
        toast.promise<TData, TError, TPending>(promise, messages, {
            ...(toastOptions as ToastOptions<TData>),
            ...options,
        }),
};

export { toastStyle, toastOptions };
